<app-balsa-card
  [loading]="dataSource.loading$ | async"
  [circleLoading]="false"
  [title]="title"
  [titleIcon]="titleIcon"
  [cardMargin]="cardMargin"
  [useMarginBottom]="useMarginBottom"
  [hasDivider]="hasDivider"
  [centered]="centered"
  [useCalculatedMaxHeight]="useCalculatedMaxHeight"
  [subtitle]="subtitle"
  [minHeight]="
    dataSource?.data?.length <= 5 || ((dataSource?.loading$ | async) && !dataSource?.data?.length)
      ? 'fit-content'
      : '300px'
  "
  [cardShadow]="cardShadow"
  [headerMargin]="headerMargin"
  [additionalHeightOffset]="additionalHeightOffset">
  <ng-container class="title-extras">
    <ng-content select=".title-extras"></ng-content>
  </ng-container>
  <ng-container class="above-card-actions">
    <div class="header-actions">
      <ng-content select=".above-card-actions"></ng-content>
    </div>
  </ng-container>
  <ng-container class="card-header">
    <ng-content select=".card-header"></ng-content>
  </ng-container>
  <ng-container class="card-actions">
    <div class="left-card-actions" [ngClass]="{ 'full-width': fullWidthSearch }">
      <ng-content select=".before-left-card-actions"></ng-content>
      @if (useDefaultSearch) {
        <div class="search-container" [ngClass]="{ 'full-width': fullWidthSearch }">
          <mat-form-field class="search-box" appearance="outline" [ngClass]="{ 'full-width': fullWidthSearch }">
            <mat-icon matIconPrefix>search</mat-icon>
            <mat-label>{{ searchLabel | translate: locale.language }}</mat-label>
            <input
              matInput
              [disabled]="disabled"
              aria-label="Search box"
              (keyup)="onKeyUp($event.target)"
              [attr.data-test]="'search'" />
          </mat-form-field>
        </div>
      }
      @if (showTenantSearch && isSuperAdmin) {
        <div class="tenant-search-info mat-small">{{ filteredTenantIdMessage }}</div>
        <app-tenant-search
          width="400px"
          [initialTenantId]="selectedTenantId"
          [tenantId]="selectedTenantId"
          placeholder="Filter by Tenant"
          (tenantSelected)="onTenantSelected($event)">
        </app-tenant-search>
      }
      <ng-content select=".left-card-actions"></ng-content>
    </div>
    <div class="right-card-actions" [ngStyle]="{ margin: useDefaultSearch ? 0 : canChangeColumns ? '1rem 0' : 0 }">
      <ng-content select=".card-actions"></ng-content>
      @if (canChangeColumns) {
        <button
          class="columns-button"
          mat-stroked-button
          color="primary"
          (click)="onOpenColumns()"
          [attr.data-test]="'columns-button'">
          <mat-icon>view_column</mat-icon>
          {{ 'Contacts.List.Buttons.Columns' | translate: locale.language }}
        </button>
      }
    </div>
  </ng-container>
  <ng-container class="card-content">
    <ng-content select=".above-table-content"></ng-content>

    <div class="table-container">
      <table
        class="data-table"
        [class.fixed-layout]="fixedTableLayout"
        mat-table
        [dataSource]="dataSource"
        [trackBy]="trackByFn"
        matSort
        multiTemplateDataRows
        (matSortChange)="sortChange.emit($event)">
        <ng-container matColumnDef="select" [sticky]="stickySelect">
          <th mat-header-cell *matHeaderCellDef [attr.data-test]="'column-header-select'" aria-label="select">
            @if (!singleSelection) {
              <mat-checkbox
                [disabled]="singleSelection || disabled"
                (change)="onToggleAll()"
                [checked]="isAllSelected()"
                [indeterminate]="isSomeSelected()"
                [matTooltip]="'Select All' | translate: locale.language"
                (keydown.enter)="onToggleAll()"
                [aria-label]="'Select All' | translate: locale.language"></mat-checkbox>
            }
          </th>
          <td mat-cell *matCellDef="let element; let i = dataIndex" [attr.data-test]="'column-select-' + i">
            <mat-checkbox
              [disabled]="
                (singleSelection && !!selection.selected.length && !selection.isSelected(element)) || disabled
              "
              (change)="this.onToggleItem(element)"
              [checked]="selection.isSelected(element)"
              (click)="$event.stopPropagation()"
              (keydown.enter)="this.onToggleItem(element)"
              [aria-labelledby]="'label-' + i"></mat-checkbox>
          </td>
        </ng-container>
        @for (column of availableColumns; track getColumnId(column); let colIndex = $index) {
          <ng-container [matColumnDef]="column.field" [sticky]="column.sticky">
            @if (column.noSort) {
              <th
                mat-header-cell
                *matHeaderCellDef
                [ngStyle]="!!column.style ? column.style : { padding: '0 0.5rem', 'min-width': '8rem' }"
                [attr.data-text]="'column-header-' + column.field"
                [innerText]="column.localizationKey || column.field | translate: locale.language"></th>
            } @else {
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                [sortActionDescription]="
                  'Sort by ' + (column.localizationKey || column.field | translate: locale.language)
                "
                [ngStyle]="!!column.style ? column.style : { padding: '0 0.5rem', 'min-width': '8rem' }"
                [attr.data-text]="'column-header-' + column.field">
                {{ column.localizationKey || column.field | translate: locale.language }}
              </th>
            }
            <td
              mat-cell
              *matCellDef="let element; let i = dataIndex"
              [ngStyle]="!!column.style ? column.style : { padding: '0 0.5rem', 'min-width': '8rem' }"
              [attr.data-test]="'column-' + column.field + '-' + i"
              [id]="colIndex === 0 ? 'label-' + i : null">
              <div style="display: flex; align-items: center">
                @if (!column.link || !column.link(element, null, column.useRedirect ? router.url : null)) {
                  <span
                    [matTooltip]="column.tooltip ? (column.tooltip(element) | translate: locale.language) : null"
                    [innerText]="getValue(column, element)">
                  </span>
                } @else {
                  <a
                    (click)="column.link(element, null, column.useRedirect ? router.url : null)?.onclick?.(element)"
                    [routerLink]="column.link(element, null, column.useRedirect ? router.url : null)?.route"
                    [href]="column.link(element, null, column.useRedirect ? router.url : null)?.href"
                    [queryParams]="column.link(element, null, column.useRedirect ? router.url : null)?.queryParams"
                    [attr.data-test]="'column-' + column.field + '-' + i + 'link'"
                    [matTooltip]="column.tooltip ? (column.tooltip(element) | translate: locale.language) : null"
                    [innerText]="getValue(column, element)">
                  </a>
                }
                @if (!!column.icon && !!column.icon(element)) {
                  <mat-icon
                    style="margin: auto; overflow: visible"
                    [matTooltip]="
                      !!column.iconTooltip ? (column.iconTooltip(element) | translate: locale.language) : null
                    "
                    [innerText]="column.icon(element)">
                  </mat-icon>
                }
              </div>
            </td>
          </ng-container>
        }

        @if (canRowExpand) {
          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element; let i = dataIndex" [attr.data-test]="'column-expansion-' + i">
              <button
                mat-icon-button
                [attr.aria-label]="
                  (expandedElement === element ? 'Collapse row' : 'Expand row') | translate: locale.language
                "
                [matTooltip]="
                  (expandedElement === element ? 'Collapse row' : 'Expand row') | translate: locale.language
                "
                [attr.aria-expanded]="expandedElement === element"
                (click)="$event.stopPropagation(); onRowClicked(element)"
                [attr.data-test]="'column-expansion-button-' + i">
                @if (expandedElement !== element) {
                  <mat-icon>keyboard_arrow_down</mat-icon>
                }
                @if (expandedElement === element) {
                  <mat-icon>keyboard_arrow_up</mat-icon>
                }
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="expanded">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedAndAdditionalCols.length">
              <div
                class="expanded-container"
                [@detailExpand]="expandedElement !== null && rowIdentity(element) === rowIdentity(expandedElement)
                  ? 'expanded' : 'collapsed'"
                [attr.aria-hidden]="element !== expandedElement">
                <ng-container *ngTemplateOutlet="expandedRow; context: { element: element }"> </ng-container>
              </div>
            </td>
          </ng-container>
        }

        <ng-content select=".additional-columns"></ng-content>
        <tr mat-header-row *matHeaderRowDef="displayedAndAdditionalCols; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedAndAdditionalCols; let i = dataIndex"
          (click)="onRowClicked(row)"
          (keydown.enter)="onRowClicked(row)"
          [tabIndex]="rowIsClickable ? 0 : -1"
          [attr.data-test]="'table-row-' + i"
          [class.row-selected]="selection.isSelected(row)"
          [class]="getRowClass(row)"></tr>
        @if (canRowExpand) {
          <tr mat-row *matRowDef="let row; columns: ['expanded']" class="expanded-row"></tr>
        }
      </table>
    </div>
    @if (dataSource?.empty$ | async) {
      <div style="margin: 1rem">
        <mat-hint>
          {{ 'No items have been found.' | translate: locale.language }}
        </mat-hint>
      </div>
    }
    <app-error-message width="100%" [error]="error$ | async" (retryClicked)="onReload(true)"></app-error-message>
  </ng-container>
  <div class="card-footer data-table-footer">
    <ng-content select=".card-footer"></ng-content>
    <mat-paginator
      [length]="dataSource?.itemCount"
      [pageSizeOptions]="availablePageSizes"
      [pageSize]="defaultPageSize"
      [class.hidden]="dataSource?.itemCount < paginatorMinimum"
      (page)="pageChange.emit($event)"
      [class.hidden-paginator]="hidePaginator">
    </mat-paginator>
  </div>
</app-balsa-card>
